import * as React from 'react';
import SwipeableViews from 'react-swipeable-views';
import { SliderProps } from './types';

export const Slider: React.SFC<SliderProps> = ({
  index,
  handleChangeIndex,
  containerStyle,
  slideStyle,
  children,
}) => (
  <SwipeableViews
    index={index}
    onChangeIndex={handleChangeIndex}
    style={containerStyle}
    slideStyle={slideStyle}
    ignoreNativeScroll
    disableLazyLoading
  >
    {children}
  </SwipeableViews>
);
